// MapDescriptor — the wire format the Go map server emits and this client consumes.
// All shapes are sourced from api/openapi.yaml via openapi-typescript codegen
// (src/gen/api.d.ts). This file is a thin aliasing layer so consumers keep
// importing familiar names (Light, Mesh, MapDescriptorV2, isV1/isV2, …) without
// reaching into the generated `components['schemas']` namespace directly.

import type { components } from './gen/api'

type S = components['schemas']

export type SourceEngine = S['SourceEngine']
export type OriginalGame = S['OriginalGame']
export type Vec3 = S['Vec3']
export type Euler = S['Euler']
export type Vec2 = S['Vec2']
export type HexColor = S['HexColor']

export type Texture = S['Texture']
export type Lightmap = S['Lightmap']
export type Shader = S['Shader']
export type SurfaceProp = S['SurfaceProp']
export type Material = S['Material']
export type Mesh = S['Mesh']

export type LightAmbient = S['LightAmbient']
export type LightDirectional = S['LightDirectional']
export type LightPoint = S['LightPoint']
export type Light = S['Light']

export type SkyCubemap = S['SkyCubemap']
export type Sky = S['Sky']
export type Fog = S['Fog']
export type Spawn = S['Spawn']
export type TriggerType = S['TriggerType']
export type Trigger = S['Trigger']
export type Prop = S['Prop']
export type StaticProp = S['StaticProp']
export type Provenance = S['Provenance']
export type MapDescriptorV2 = S['MapDescriptorV2']

export type V1Light = S['V1Light']
export type V1LightType = V1Light['type']
export type V1MaterialGrid = S['V1MaterialGrid']
export type V1MaterialStripe = S['V1MaterialStripe']
export type V1Material = S['V1Material']
export type V1BoxBrush = S['V1BoxBrush']
export type V1EndTrigger = S['V1EndTrigger']
export type MapDescriptorV1 = S['MapDescriptorV1']

export type MapDescriptor = S['MapDescriptor']

export function isV1(desc: MapDescriptor): desc is MapDescriptorV1 {
  return desc.version === 1
}

export function isV2(desc: MapDescriptor): desc is MapDescriptorV2 {
  return desc.version === 2
}
